var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import WindowStateContext from '../../context/window-state-context';
import { getGeometryStyle, getMaximumHeight, getMaximumWidth, getMinimumHeight, getMinimumWidth, getTextAlignment, getWidth, updateStylesheet } from '../../helpers/styles';
var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + " !important;\n  min-width: " + getMinimumWidth(minimumSize) + " !important;";
};
var getMaxHeightWidth = function (maximumSize) {
    return "\n  max-height: " + getMaximumHeight(maximumSize) + ";\n  max-width: " + getMaximumWidth(maximumSize) + ";";
};
var StyledLabel = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n    ", "\n    box-sizing: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n  color: ", ";\n  display: ", ";\n  ", "\n  background-color: ", ";\n  border: ", ";\n  border-color: ", ";\n  ", ";\n  ", "\n  font-size: ", ";\n  font-weight: ", ";\n\n  padding-left: ", ";\n  padding-right: ", ";\n  ", ";\n  ", "\n"], ["\n  ", "\n  ",
    "\n    ",
    "\n    box-sizing: ", ";\n  flex-direction: ", ";\n  justify-content: ", ";\n  color: ",
    ";\n  display: ", ";\n  ", "\n  background-color: ",
    ";\n  border: ",
    ";\n  border-color: ", ";\n  ", ";\n  ",
    "\n  font-size: ", ";\n  font-weight: ", ";\n\n  padding-left: ", ";\n  padding-right: ", ";\n  ", ";\n  ",
    "\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        attributes.minimumSize &&
        getMinHeightWidth(attributes.minimumSize);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        attributes.maximumSize &&
        getMaxHeightWidth(attributes.maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.boxSizing;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.flexDirection;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.justifyContent;
}, function (_a) {
    var windowTheme = _a.windowTheme, disabled = _a.disabled, fontColor = _a.fontColor;
    return disabled
        ? windowTheme.label.disabledColor
        : fontColor !== null && fontColor !== void 0 ? fontColor : windowTheme.label.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return getWidth(windowTheme.label.width);
}, function (_a) {
    var attributes = _a.attributes, windowTheme = _a.windowTheme, backgroundColor = _a.backgroundColor;
    var _b;
    return backgroundColor
        ? backgroundColor + " !important"
        : (_b = attributes.backgroundColor) !== null && _b !== void 0 ? _b : windowTheme.label.backgroundColor;
}, function (_a) {
    var windowTheme = _a.windowTheme, noBorder = _a.noBorder;
    return noBorder === 'true' ? "none" : windowTheme.label.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.borderColor;
}, function (_a) {
    var headerType = _a.headerType, windowTheme = _a.windowTheme;
    return getHeaderStyle(windowTheme, headerType);
}, function (_a) {
    var attributes = _a.attributes;
    return attributes &&
        (attributes.alignment || attributes.textAlignment) &&
        getTextAlignment(attributes.alignment || attributes.textAlignment);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.fontSize;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.fontWeight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.paddingLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.paddingRight;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes.styleSheet;
}, function (_a) {
    var attributes = _a.attributes, type = _a.type;
    return attributes &&
        attributes.styleSheet &&
        updateStylesheet(attributes.styleSheet._, type);
});
var getHeaderStyle = function (windowTheme, headerType) {
    return "\n        " + (headerType === 'subheader'
        ? "\n            text-align : " + windowTheme.label.header.alignItems + ";\n            background-color : " + windowTheme.label.header.subheaderbgColor + ";\n            width: " + windowTheme.label.header.width + "\n        "
        : headerType === 'header'
            ? "\n            text-align : " + windowTheme.label.header.alignItems + ";\n            background-color : " + windowTheme.label.header.headerbgColor + ";\n            width: " + windowTheme.label.header.width + "\n        "
            : "\n        text-align : " + windowTheme.label.alignItems + ";\n    ") + ";\n    ";
};
var Span = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  white-space: ", ";\n"], ["\n  width: ", ";\n  white-space: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.label.span.width;
}, function (_a) {
    var windowTheme = _a.windowTheme, hasNewLine = _a.hasNewLine;
    return hasNewLine ? windowTheme.label.whiteSpace : 'nowrap';
});
var Label = function (props) {
    var _onLabelClick = useContext(WindowEventContext)._onLabelClick;
    var stateFromEnv = useContext(WindowStateContext);
    var identifier = props.identifier, restProps = __rest(props, ["identifier"]), _a = props.attributes, text = _a.text, title = _a.title, _b = _a.noBorder, noBorder = _b === void 0 ? false : _b;
    var valuesFromEnv = stateFromEnv.fields;
    var fontColor = valuesFromEnv[identifier + "_fontColor"];
    var backgroundColor = valuesFromEnv[identifier + "_backgroundColor"];
    var hasQRichText = text && (text.includes('qrichtext') || text.includes('<html>'));
    var textFromState = valuesFromEnv["" + identifier];
    var hasNewLine = text && text.includes('\n');
    var headerType = identifier && identifier.includes('subheader')
        ? 'subheader'
        : identifier && identifier.includes('header')
            ? 'header'
            : 'notHeader';
    var handleClick = function () {
        _onLabelClick(identifier);
    };
    console.log({ noBorder: noBorder });
    return (React.createElement(StyledLabel, __assign({}, restProps, { headerType: headerType, onClick: handleClick, fontColor: fontColor, backgroundColor: backgroundColor, noBorder: noBorder }), hasQRichText ? (React.createElement(Span, { windowTheme: restProps.windowTheme, dangerouslySetInnerHTML: { __html: text }, hasNewLine: hasNewLine })) : (React.createElement(Span, { windowTheme: restProps.windowTheme, hasNewLine: hasNewLine }, textFromState || title || text))));
};
export default Label;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map